import React, { type ComponentProps, useEffect, useState } from 'react';

import { useTheme } from '@emotion/react';
import { Heading } from '@lucid/components';

import type { Lucid } from 'types/types';

type Props = Omit<ComponentProps<typeof Heading>, 'as'>;

//The maximum is exclusive and the minimum is inclusive
const getRandomInt = (min: number, max: number) => {
  min = Math.ceil(min);
  max = Math.floor(max);

  return Math.floor(Math.random() * (max - min) + min);
};

const thickness = 3;
const xOffset = 20;
const yOffset = 24;

const FlourishedHeading = (props: Props) => {
  const [colorVariant, setColorVariant] = useState<string[]>();
  const [lineVariant, setLineVariant] = useState<number[]>();
  const theme: Lucid.Theme.Brand = useTheme();

  useEffect(() => {
    const indigo = theme.colors.indigo[60];
    const blue = theme.colors.blue[60];
    const pink = theme.colors.pink[60];
    const grey = theme.colors.coolGrey[100];

    const lineVariants = [
      [3, 4, 3],
      [2, 4, 4],
      [2, 4, 3],
    ];
    const colorVariants = [
      [indigo, blue, pink],
      [indigo, grey, blue],
      [blue, grey, pink],
    ];

    setLineVariant(lineVariants[getRandomInt(0, lineVariants.length)]);
    setColorVariant(colorVariants[getRandomInt(0, colorVariants.length)]);
  }, [theme]);

  return (
    <>
      {lineVariant && colorVariant && (
        <svg
          css={{
            height: '50px',
            overflow: 'visible',
          }}
          viewBox="0 0 100 50"
        >
          <line
            stroke={colorVariant[0]}
            strokeWidth={thickness}
            x1="0"
            x2={21.65 * lineVariant[0]}
            y1={50}
            y2={50 - 12.5 * lineVariant[0]}
          />
          <line
            stroke={colorVariant[1]}
            strokeWidth={thickness}
            x1={xOffset}
            x2={21.65 * lineVariant[1] + xOffset}
            y1={50}
            y2={50 - 12.5 * lineVariant[1]}
          />
          <line
            stroke={colorVariant[2]}
            strokeWidth={thickness}
            x1={0}
            x2={21.65 * lineVariant[2]}
            y1={50 + yOffset}
            y2={50 - 12.5 * lineVariant[2] + yOffset}
          />
        </svg>
      )}
      <Heading
        as="h2"
        {...props}
        css={theme => ({
          marginTop: theme.space.s24,
        })}
      />
    </>
  );
};

export default FlourishedHeading;
